import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des pays
 */
@Injectable()
export class PaysService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);

    //Cas spécifique, car service accessible depuis la page register
    //donc sans être logué. Et sur rechargement (F5), le appSettings
    //est chargé après la construction de ce service
    if (this.s_global.pathAPI === "pathAPI") {
      this.s_appsettings.proc_getSettings().subscribe(settings => {
        this.s_global.pathAPI = settings.pathAPI;
        this.w_baseUrl = this.s_global.pathAPI + "/pays";
      });
    } else this.w_baseUrl = this.s_global.pathAPI + "/pays";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de recuperation de tous les pays
   * Retour : json avec la liste de tous les pays
   */
  public proc_getAll(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getall`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation des pays par le code en paramètre
   * Retour : json avec la liste des pays choisis
   *
   */

  public proc_getByCode(str: String): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getByCode/${str}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'une pays par son id
   * Parametres : paysId de pays
   * Retour : json avec la pays
   */
  public proc_getById(id: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/${id}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'une pays dans la BDD
   * Parametres : pays a ajouter
   */
  public proc_add(pays: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/add`,
      JSON.stringify(pays),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de mise a jour d'une pays dans la BDD
   * Parametres : pays a modifier
   */
  public proc_update(pays: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/update`,
      JSON.stringify(pays),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de suppression d'une pays dans la BDD
   * Parametres : pays a supprimer
   */
  public proc_delete(pays: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/delete`,
      JSON.stringify(pays),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de tous les pays avec autres champs du table liées
   * Retour : json avec la liste de tous les pays avec autres champs du table liées
   */
  public proc_getJsonPays(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getJsonPays`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction estUtilise pour verifier si les données a supprimer sont utilisés
   * Parametres : paysId
   */
  public proc_estUtilise(paysId: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/estUtilise/${paysId}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation des Pays
   */
  public proc_getJsonPaysPasAPas(i_tiers: number, state: any): Observable<any> {
    let w_sort_column = "";
    if (state.sort[0] != null) w_sort_column = state.sort[0].field;

    return this.http.post(
      `${this.w_baseUrl}/getJsonPaysPasAPas`,
      JSON.stringify({
        start: state.skip,
        rows: state.take,
        sort_column: w_sort_column
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/pays.service.ts